import React from "react";
import './Loading.css'
import {useLoadingState} from "../../context/LoadingContext";

import loadingAnim from '../../assets/lottie/loading.json';
import {Player} from "@lottiefiles/react-lottie-player";

export default function Loading() {

    const loadingState = useLoadingState()

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingAnim,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <div className={` ${loadingState.loading ? 'd-block' : 'd-none'}`}>
            <div
                className={` ${loadingState.showBackground ? 'loading loadingBackgroundWhite' : 'loading loadingBackgroundBlur'}`}>
                <div>
                    <Player
                        style={{width:'100px'}}
                        loop
                        autoplay
                        className="player"
                        src={loadingAnim}
                    />
                </div>
            </div>

        </div>
    )
}
